<div class="cw-flex-row">
  <h2>{{ 'GENERAL.ORDEROVERVIEW' | translate }}</h2>

  <phscw-toolbar
    componentIdentifier="order-form"
    [componentConnection]="$any(this)"
    [buttonEditmode]="this.orderFormService.isOrderChangeable(dataItem.order_status)"
    [buttonCancel]="true"
    [buttonClose]="showClose && !editMode">
  </phscw-toolbar>
</div>

<phscw-order-form-header
  [orderData]="dataItem"
  [institutionId]="institutionId"
  [editMode]="editMode">
</phscw-order-form-header>

<phscw-order-form-items
  [orderData]="dataItem"
  [editMode]="editMode"
  (valueChanges)="onItemsValueChanges($event)">
</phscw-order-form-items>

<phscw-order-form-footer [orderData]="dataItem" [editMode]="editMode"></phscw-order-form-footer>

<!-- Timestamps + Bestellbestätigung nachträglich versenden (auf gleicher Höhe) -->
@if (orderId > 0 && !editMode) {
  <div class="cw-horizontalline"></div>
  <div class="cw-timestamps-with-confirmation">
    @if (showCreateEditUserDate) {
      <div class="cw-timestamps-block">
        <phscw-output-timestamp
          class="cw-flex-row"
          label="{{ 'GENERAL.CREATION' | translate }}"
          [timestamp]="dataItem.create_date"
        additional="{{ dataItem.create_user }}"></phscw-output-timestamp>
        <phscw-output-timestamp
          class="cw-flex-row"
          label="{{ 'GENERAL.ALTERATION' | translate }}"
          [timestamp]="dataItem.edit_date"
        additional="{{ dataItem.edit_user }}"></phscw-output-timestamp>
      </div>
    }
    @if (showConfirmationSendButton) {
      <button
        mat-raised-button
        color="warn"
        type="button"
        [disabled]="isSendingConfirmation"
        (click)="clickSendConfirmation()">
        {{ 'SHARED.ORDERTRACKING.SENDCONFIRMATION' | translate }}
      </button>
    }
  </div>
}

<!-- Buttons Submit & Cancel -->
@if (editMode) {
  <div class="cw-button-wrapper">
    @if (!areAllFormsValid()) {
      <span>INVALID FORM</span>
    }
    <button mat-raised-button color="accent" type="submit" (click)="clickSubmit(true)" [disabled]="!areAllFormsValid() || saving">
      {{ 'GENERAL.SEND' | translate }}
      <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
    </button>
    <button mat-raised-button color="accent" type="submit" (click)="clickSubmit()" [disabled]="!areAllFormsValid() || saving">
      {{ 'GENERAL.SAVE' | translate }}
      <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
    </button>
    <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
      {{ 'GENERAL.CANCEL' | translate }}
    </button>
  </div>
}
